import { Box, IconButton, Button } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "@context/ThemeContext";

type Variant = "compact" | "footer";

interface ThemeLangActionsProps {
  variant?: Variant;
}

export function ThemeLangActions({
  variant = "compact",
}: ThemeLangActionsProps) {
  const { mode, toggleTheme } = useThemeMode();
  const { i18n } = useTranslation();

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === "en" ? "hr" : "en");
  };

  if (variant === "footer") {
    return (
      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <IconButton onClick={toggleTheme} size="small">
          {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        <Button
          size="small"
          onClick={toggleLang}
          sx={{ minWidth: 40, fontWeight: 600 }}
        >
          {i18n.language === "en" ? "HR" : "EN"}
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Button
        size="small"
        onClick={toggleLang}
        sx={{ minWidth: 40, flexShrink: 0 }}
      >
        {i18n.language.toUpperCase()}
      </Button>
      <IconButton onClick={toggleTheme} size="small" sx={{ flexShrink: 0 }}>
        {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </>
  );
}
